/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum BopReadMoreMode {
    AvailabilityFlag = 'AVAILABILITY_FLAG',
    FullText = 'FULL_TEXT',
    NoMetadata = 'NO_METADATA'
}

export function BopReadMoreModeFromJSON(json: any): BopReadMoreMode {
    return BopReadMoreModeFromJSONTyped(json, false);
}

export function BopReadMoreModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BopReadMoreMode {
    return json as BopReadMoreMode;
}

export function BopReadMoreModeToJSON(value?: BopReadMoreMode | null): any {
    return value as any;
}

